function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App from 'modules/App';
import messages from '../../../../messages';
import { GUARDIAN_CONFIRMATION_STATUS_MODAL } from '../../../../constants';
import { renderCheckSpam } from '../../renderers';
import styles from './ConfirmationStatusModal.pcss';
const ConfirmationStatusModal = ({ status, email })=>{
    useStyles(styles);
    const openModalId = useSelector(App.selectors.modal);
    const onCloseModal = useAction(App.actions.closeModal);
    let Content = null;
    let headerMessage = null;
    switch(status){
        case 'Pending':
            Content = /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-3 text-align--stretch",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.confirmGuardianEmailPending), {
                            values: {
                                email: /*#__PURE__*/ _jsx("b", {
                                    children: email
                                })
                            }
                        }))
                    }),
                    renderCheckSpam()
                ]
            });
            headerMessage = messages.headers.confirmGuardianEmailPending;
            break;
        case 'Failed':
            Content = /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-3 text-align--stretch",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.confirmGuardianEmailFailed), {
                            values: {
                                email: /*#__PURE__*/ _jsx("b", {
                                    children: email
                                })
                            }
                        }))
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-align--stretch",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.enterNewGuardianEmail))
                    })
                ]
            });
            headerMessage = messages.headers.confirmGuardianEmailFailed;
            break;
        default:
            break;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.modal__wrapper,
        children: /*#__PURE__*/ _jsxs(Modal, {
            modalId: GUARDIAN_CONFIRMATION_STATUS_MODAL,
            openModalId: openModalId,
            headerMessage: headerMessage,
            styleModifier: "md",
            children: [
                Content,
                /*#__PURE__*/ _jsx("div", {
                    className: "w-100",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "reset",
                        styleModifier: "primary",
                        className: "btn--block btn--filled",
                        labelMessage: App.messages.buttons.ok,
                        onClick: onCloseModal
                    })
                })
            ]
        })
    });
};
export default ConfirmationStatusModal;
